@import '../scss/base';

:host {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
}

div {
  display: flex;
  flex: 1 1 auto;

  // flex direction
  &.column {
    flex-direction: column;
  }

  &.column-reverse {
    flex-direction: column-reverse;
  }

  &.row {
    flex-direction: row;
  }

  &.row-reverse {
    flex-direction: row-reverse;
  }

  // wrap
  &.no-wrap {
    flex-wrap: nowrap;
  }

  &.wrap {
    flex-wrap: wrap;
  }

  &.wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  // justify content
  &.justify-content-start {
    justify-content: start;
  }

  &.justify-content-end {
    justify-content: end;
  }

  &.justify-content-center {
    justify-content: center;
  }

  &.justify-content-space-between {
    justify-content: space-between;
  }

  &.justify-content-space-around {
    justify-content: space-around;
  }

  &.justify-content-space-evenly {
    justify-content: space-evenly;
  }

  // align items
  &.align-items-start {
    align-items: start;
  }

  &.align-items-end {
    align-items: end;
  }

  &.align-items-center {
    align-items: center;
  }

  &.align-items-stretch {
    align-items: stretch;
  }

  &.align-items-baseline {
    align-items: baseline;
  }

  // align content
  &.align-content-normal {
    align-content: normal;
  }

  &.align-content-start {
    align-content: start;
  }

  &.align-content-end {
    align-content: end;
  }

  &.align-content-center {
    align-content: center;
  }

  &.align-content-space-between {
    align-content: space-between;
  }

  &.align-content-space-around {
    align-content: space-around;
  }

  &.align-content-space-evenly {
    align-content: space-evenly;
  }

  &.align-content-stretch {
    align-content: stretch;
  }

  // gap
  &.gap-wide {
    gap: css-var(comp-stack-gap-wide);
  }

  &.gap-default {
    gap: css-var(comp-stack-gap-default);
  }

  &.gap-narrow {
    gap: css-var(comp-stack-gap-narrow);
  }

  &.gap-condensed {
    gap: css-var(comp-stack-gap-condensed);
  }

  &.gap-extra-condensed {
    gap: css-var(comp-stack-gap-extra-condensed);
  }

  &.gap-zero {
    gap: css-var(comp-stack-gap-0);
  }
}
